<template>
  <div class="container pull-up">
    <v-row class="d-flex justify-center" align="center">
      <v-col cols="7">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            <el-form :rules="rules" ref="form" :model="data">
              <v-row>
                <v-col cols="12">
                  <v-select v-model="data.department" :items="departments" filled
                            color="blue-grey lighten-2" label="Select department" item-text="name"
                            @change="data.user = ''"
                            item-value="id"></v-select>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="data.user" :items="filterUsers" filled
                                  color="blue-grey lighten-2" label="Select user" item-text="name"
                                  item-value="id">
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.name }}
                          <v-chip x-small color="success" class="ml-2" v-if="item.has_active_session">Active Session</v-chip>
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <template v-slot:selection="{ item }">
                      <span>{{ item.name }}</span>
                      <v-chip x-small color="success" class="ml-2" v-if="item.has_active_session">Active Session</v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model.number="data.opening_amount" placeholder="Enter opening amount" filled
                                :rules="rules.amount">
                    <template #prepend-inner>
                      <v-icon>mdi-cash</v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </el-form>
          </v-card-text>
          <v-divider class="mx-2 mb-0"/>
          <v-card-actions>
            <v-row class="d-flex justify-space-between" align="center">
              <v-col cols="auto">
                <v-btn color="warning" depressed :to="{name: 'sessions'}">
                  <v-icon left>mdi-arrow-left-circle</v-icon>
                  Cancel
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn color="primary" @click.prevent="createSession">
                  Create Session
                  <v-icon right>mdi-check-circle</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'create-category',
  data () {
    return {
      loading: false,
      users: [],
      departments: [],
      data: {
        user: '',
        department: '',
        opening_amount: ''
      },
      rules: {
        user: [
          {
            required: true,
            trigger: ['blur', 'change']
          }
        ],
        department: [
          {
            required: true,
            trigger: ['blur', 'change']
          }
        ],
        amount: [
          v => !isNaN(v) || 'Please, enter a valid amount'
        ]
      }
    }
  },
  computed: {
    filterUsers () {
      return this.data.department
        ? this.users.filter(u => parseInt(u.department_id) === this.data.department).map(u => ({
          ...u,
          disabled: !u.active || u.has_active_session
        }))
        : this.users.map(u => ({
          ...u,
          disabled: !u.active
        }))
    }
  },
  methods: {
    async getUsersDepartments () {
      this.getUsers()
      this.getDepartments()
    },
    getUsers () {
      this.$sessionService.getSessionableUsers()
        .then((users) => {
          this.users = users.filter(u => !parseInt(u.is_admin))
        })
    },
    getDepartments () {
      this.$departmentService.getDepartments()
        .then((data) => {
          this.departments = data
          // If there's only one department, automatically set it as the active department
          if (data.length === 1) {
            this.data.department = data[0].id
          }
        })
    },
    validateInputs () {
      return new Promise((resolve, reject) => {
        this.data.department && this.data.user ? resolve() : reject(new Error(!this.data.department ? 'Select a department' : 'Select a user'))
      })
    },
    async createSession () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await this.withLoading(async () => {
              await this.validateInputs()
              await this.askQuestion(this.$t('session.confirm.create'), async () => {
                const data = await this.$sessionService.createSession(this.data)
                this.showSuccess(this.$t('session.message.created'))
                await this.$router.push({
                  name: 'sessions',
                  query: { department: this.data.department }
                })
              })
            }, 'loading')
          } catch (error) {
            console.log('Component caught error in createSession:', error)
          }
        }
      })
    },
    resetForm () {
      this.$refs.form.resetFields()
    }
  },
  mounted () {
    this.$emit('parent-title', this.$t('session.title.create'))
    this.getUsersDepartments()
  }
}
</script>
<style>
input[type="file"].el-upload__input {
  display: none;
}

.avatar-uploader .el-upload {
  position: inherit !important;
}

.full-width {
  width: 100%;
}

.validator {
  color: #ef7100;
  font-weight: bold;
}

.required {
  color: #ef1900;
  font-weight: bold;
}

.avatar-uploader .el-upload {
  position: fixed;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon:hover {
  opacity: .4;
  background-color: rgba(21, 21, 21, .5);
  color: #FFFFFF;
}

.avatar-uploader-icon {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 90px;
  text-align: center;
  cursor: pointer;
}

.avatar-uploader-icon:hover {
  opacity: 1;
}

[class^="el-icon-"] {
  display: inherit;
}

</style>
